// extracted by mini-css-extract-plugin
module.exports = {"launchbutton":"style__launchbutton__z-wq8","button":"style__button__bu0BV"};